/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-21 21:04:48
 * @FilePath: \baishu_react_ui\src\components\BsyDept\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsyDept from "../BsyDept";

export default class BsyDeptGroup extends BsyDept {
  static defaultProps = {
    baseCls: "bsy-dept bsy-dept-group",
    width: 720,
    height: 80,
    value: [],
    onRelyLimit: null,
    type: "deptgroup",
  };

  constructor(props) {
    super({
      type: "deptgroup",
      ...props,
    });

    // this.state = {
    //   dynamicFields: [{
    //     _id: BsyConfig().CONST.DEPT_ID.CURRENT,
    //     name: React.language("dept.current")
    //   }, {
    //     _id: BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT,
    //     name: React.language("department.sub.department")
    //   }],
    //   dynamicKey: [
    //     BsyConfig().CONST.DEPT_ID.CURRENT,
    //     BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT
    //   ],
    //   ...props,
    //   value: this.getValueIds(props.value)
    // }
    // this.element = React.createRef();
    // this.value = this.getValueIds(props.value)
    // this.current_departments();
  }

  // componentDidMount = () => {
  //   super.componentDidMount();
  //   // this.current_departments()
  // }

  current_departments = () => {
    return;
  };

  listMemberName = () => {
    const { value, ftoken } = this.state;
    if (ftoken) {
      return;
    }
    let that = this;
    if (BsyUtils.isObjectEmpty(value)) {
      return;
    }

    var tmpval = [];
    let s = [];
    BsyUtils.forEach(value, (a, b) => {
      tmpval.push(b);
      if (window.deptSelectMap[b]) {
        return;
      }
      s.push(b);
    });
    if (BsyUtils.isObjectEmpty(s)) {
      that.setState({ value: tmpval });
      return;
    }

    React.axios("/corp/list_member_name", {
      members: s,
    })
      .then((res) => {
        let a = res.data;
        let d = [];
        if (a.virtually && a.virtually.length > 0) {
          BsyUtils.forEach(a.virtually, function (k, z) {
            switch (z.mode) {
              case "role":
                a.roles || (a.roles = []);
                a.roles.push(z);
                break;
              case "outsider":
                a.outsiderMember || (a.outsiderMember = []);
                a.outsiderMember.push(z);
                break;
              case "member":
                a.users || (a.users = []);
                a.users.push(z);
                break;
              case "outsiderGroup":
                a.outsiderGroup || (a.outsiderGroup = []);
                a.outsiderGroup.push(z);
                break;
              case "current":
              case "currentSub":
                a.job_title || (a.job_title = []);
                a.job_title.push(z);
                break;
              case "relationUser":
                a.userRelation || (a.userRelation = []);
                a.userRelation.push(z);
                break;
              case "relationDept":
                a.deptRelation || (a.deptRelation = []);
                a.deptRelation.push(z);
                break;
              case "deptSub":
              case "dept":
                a.departments || (a.departments = []);
                a.departments.push(z);
              default:
                break;
            }
          });
        }
        BsyUtils.forEach(a.departments, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "departments",
          });
        });
        BsyUtils.forEach(a.dockcorp, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "dockcorp",
          });
        });
        BsyUtils.forEach(a.dockuser, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "dockuser",
          });
        });
        BsyUtils.forEach(a.dockrole, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "dockrole",
          });
        });
        BsyUtils.forEach(a.dockdept, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "dockdept",
          });
        });
        BsyUtils.forEach(a.outsiderGroup, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "outsiderGroup",
          });
        });
        let items = d.concat(that._getDynamicFields());
        BsyUtils.forEach(items, function (t, i) {
          i && (window.deptSelectMap[i._id] = i);
        });
        that.setState({ value: tmpval });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  getValue = () => {
    return this.value;
  };

  setValue = (val) => {
    if (val) {
      if (BsyUtils.isObjectEmpty(val)) {
        val = [];
      }
    }
    this.value = this.getValueId(val);
    this.setState(
      {
        value: this.value,
      },
      () => {
        this.listMemberName();
      }
    );
  };

  renderDisablePane = () => {
    const { value, islinkQuery, ftoken, appId, is_dock_form } = this.state;

    if (ftoken && !islinkQuery) {
      return (
        <div className="nonsupport-msg">
          {React.language("outlink.tip.user")}
        </div>
      );
    }

    let text = [];
    if (!BsyUtils.isObjectEmpty(value)) {
      value.map((v) => {
        let item = window.deptSelectMap[v];
        if (item) text.push(BsyUtils._toDeptUser(item));
      });
    }

    return (
      <div
        className="bsy_form_item_disable bsy-select-dept"
        data-watermark={React.language("content.empty")}
      >
        {BsyUtils.isObjectEmpty(text) ? (
          ""
        ) : (
          <ul className="select-list">
            {value.map((v) => {
              let item = window.deptSelectMap[v];
              let text = BsyUtils._toDeptUser(item);
              return item ? (
                <li
                  className="select-item"
                  id={v}
                  onClick={(e) => {
                    BsyUtils.showUserInfo(item, null, e, appId, is_dock_form);
                  }}
                >
                  <i className="select-icon icon-department"></i>
                  {/*{item.type === "dockdept" && !!item.dept_corp && <span style={{margin: '0 2px 0 0'}}>{item.dept_corp + " - "}</span>}*/}
                  <span className={item.status === -99 ? "deleted" : ""}>
                    {text}
                  </span>
                  {/*{item.type === "dockcorp" && <span style={{color: '#999','margin-left': '6px','font-size': '14px'}}>({React.language('contact.docking.people')})</span>}*/}
                </li>
              ) : (
                ""
              );
            })}
          </ul>
        )}
      </div>
    );
  };

  renderBody = () => {
    const { value, islinkQuery, ftoken } = this.state;
    if (ftoken && !islinkQuery) {
      return (
        <div className="nonsupport-msg">
          {React.language("outlink.tip.deptgroup")}
        </div>
      );
    } else {
      return (
        <ul className="select-list" onClick={this.onClick}>
          {!BsyUtils.isObjectEmpty(value) ? (
            value.map((v) => {
              let item = window.deptSelectMap[v];
              if (BsyUtils.isObjectEmpty(item)) {
                item = { id: value };
              }
              return item ? (
                <li className="select-item" id={v}>
                  <i
                    className={`select-icon ${
                      item.type === "outsiderGroup" || item.mode === "outsider"
                        ? "icon-outsider-group"
                        : item.type === "dockcorp"
                        ? "icon-bby-iconqiyeshezhi"
                        : "icon-department"
                    }`}
                  ></i>
                  {/*{item.type === "dockdept" && !!item.dept_corp && <span style={{margin: '0 2px 0 0'}}>{item.dept_corp + " - "}</span>}*/}
                  <span className={item.status === -99 ? "deleted" : ""}>
                    {item.name || item.nickname || v}
                  </span>
                  {/*{item.type === "dockcorp" && <span style={{color: '#999','margin-left': '6px','font-size': '14px'}}>({React.language('contact.docking.people')})</span>}*/}
                </li>
              ) : (
                ""
              );
            })
          ) : (
            <div className="select-empty">
              {React.language("widget.dept.clickToSelect1")}
            </div>
          )}
        </ul>
      );
    }
  };
}
